import { render, staticRenderFns } from "./ProjectConfigurationImage.vue?vue&type=template&id=54988f58&scoped=true&"
import script from "./ProjectConfigurationImage.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationImage.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationImage.vue?vue&type=style&index=0&id=54988f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54988f58",
  null
  
)

export default component.exports